module.exports = __webpack_public_path__ + "site/img/icon-treasury.cafe4f6d.svg";